export const ShareSpaceModel = Symbol('ShareSpaceModel');
